/** @format **/
import React, { FunctionComponent, useEffect, useState } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import EditButton from '../../components/Buttons/EditButton';
import I18n from '../../components/Translate/I18n';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';
import { SimCardServiceTemplate } from '../../interfaces/platform/SimCardServiceTemplate';
import PlatformResellerInterface from '../../interfaces/platform/PlatformResellerInterface';
import { ApiCollectionInterface } from '../../interfaces/collections/ApiCollectionInterface';

type VirtualComponentItemsType = {
    classes: any;
    item: SimCardServiceTemplate;
    setActiveRow: (id: number) => void;
    activeRow: number;
    viewCallback: (iri: { uri: string }, event: any) => void;
    deleteCallback: (iri: { uri: string }, event: any) => void;
    platformResellers: ApiCollectionInterface<PlatformResellerInterface>;
};

export const VirtualComponentItems: FunctionComponent<VirtualComponentItemsType> = ({
    classes,
    item,
    activeRow,
    setActiveRow,
    viewCallback,
    deleteCallback,
    platformResellers,
}): React.ReactElement => {
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRoot };
    const tableRowRoot = { root: classes.tableRowRoot };

    let rowActiveColor = 'white';
    if (activeRow === item.id) {
        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
    }

    const getPlatformResellerName = (platformResellerId: number): string => {
        if (platformResellers) {
            for (let i = 0; i < platformResellers['hydra:member'].length; i++) {
                if (platformResellers['hydra:member'][i].id === platformResellerId) {
                    return platformResellers['hydra:member'][i].mainname;
                }
            }
        }
        return '';
    };

    return (
        <TableRow
            classes={tableRowRoot}
            key={'key' + item.id}
            hover
            onClick={(): void => {
                setActiveRow(item.id);
            }}
            style={{ backgroundColor: rowActiveColor }}
        >
            <TableCell classes={tableControlStickyHeader} padding="none" align="left" style={{ backgroundColor: rowActiveColor }}>
                {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TEMPLATE_UPDATE) &&
                    UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_VIRTUAL_COMPONENT_UPDATE) && (
                        <EditButton
                            callback={viewCallback}
                            callbackParam={{ uri: item['@id'] }}
                            tooltipTitle="prov:features.edit_template_group"
                            tooltipPlacement="bottom-start"
                        />
                    )}
                {/*{UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TEMPLATE_DELETE) && (*/}
                {/*    <DeleteButton*/}
                {/*        callback={deleteCallback}*/}
                {/*        callbackParam={{ uri: item['@id'] }}*/}
                {/*        tooltipTitle="prov:features.delete_template_group"*/}
                {/*        tooltipPlacement="bottom-start"*/}
                {/*    />*/}
                {/*)}*/}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.id}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {getPlatformResellerName(item.platformResellerId)}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.templateName}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.active && <I18n trans="general:common.yes" />}
                {!item.active && <I18n trans="general:common.no" />}
            </TableCell>
        </TableRow>
    );
};
